import { Routes, Route, Navigate } from 'react-router-dom';

import ContactUsContainer from './contact-us/ContactUs.container';
import FrequentlyAskedQuestionsContainer from './frequently-asked-questions/FrequentlyAskedQuestions.container';
import TutorialsContainer from './tutorials/Tutorials.container';

const HelpCenterContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/help-center/frequently-asked-questions" />} />
      <Route path="/contact-us" element={<ContactUsContainer />} />
      <Route path="/frequently-asked-questions" element={<FrequentlyAskedQuestionsContainer />} />
      <Route path="/tutorials" element={<TutorialsContainer />} />
    </Routes>
  );
};

export default HelpCenterContainer;
